// extracted by mini-css-extract-plugin
export var active = "languageSelector-module--active--65213";
export var div = "languageSelector-module--div--5ab5a";
export var link = "languageSelector-module--link--1dbbe";